<template>
    <a-modal
            title="抽样检测项目详情"
            okText="确认"
            cancelText="取消"
            width="1000px"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
            :footer="null"
    >
        <a-form-model ref="ruleForm" :label-col="{span:6}" :wrapper-col="{span:18}">
            <a-row>
                <a-col :span="24">
                    <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="所属方案">
                        <span style="font-weight: 700">{{planName}}</span>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row>
                <a-col :span="24">
                    <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="所属方案">
                        <span style="font-weight: 700">{{projectName}}</span>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row>
                <a-col :span="24">
                    <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="牵头单位">
                        <span style="font-weight: 700">{{leaderName}}</span>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row>
                <a-col :span="24">
                    <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="机构名称">
                        <span style="font-weight: 700">{{execName}}</span>
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row>
                <a-col :span="24">
                    <a-form-model-item :labelCol="{span:4}" :wrapperCol="{span:20}" label="监测项目实施时间">
                        <a-row>
                            <a-col :span="24">
                                <div style="display: inline-block;width: 200px">
                                    <a-input disabled v-model="startDate"></a-input>
                                </div>
                                 至
                                <div style="display: inline-block;width: 200px">
                                <a-input disabled v-model="endDate"></a-input>
                                </div>
                            </a-col>
                        </a-row>

                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-row>
                <span style="font-weight: 700">已完成检测{{finishCount}}</span>
            </a-row>


            <a-table bordered :data-source="dataSource" :columns="columns" :pagination="false">
                <template slot="operation" slot-scope="text, record">
                    <a-space>
                        <a-button v-if="record.pickFileId" type="link" @click="onPickResultUploadOpen2(record,true)">查看抽样单</a-button>
                        <span v-else style="color: darkgray;margin-left: 16px;margin-right: 16px">查看抽样单</span>
                        <a-divider dashed="true" type="vertical" />
                        <a-button v-if="record.checkFileId" type="link" @click="onCheckInfoModalOpen(record)">查看检测单</a-button>
                        <span v-else style="color: darkgray;margin-left: 16px;margin-right: 16px">查看检测单</span>
                    </a-space>
                </template>
            </a-table>
        </a-form-model>
        <pick-result-upload v-if="pickResultUploadVisable" :visible.sync="pickResultUploadVisable" :param="pickResultUploadParam" ></pick-result-upload>
        <check-info-modal v-if="checkInfoModalVisable" :visible.sync="checkInfoModalVisable" :param="checkInfoModalParam" ></check-info-modal>
    </a-modal>
</template>

<script>
    import  CheckInfoModal from './CheckInfoModal'
    import PickResultUpload from './PickResultUpload'
    import {getTaskMonitDetail as initApi} from '../../../api/api'
    export default {
        name: "FormModel",
        components:{CheckInfoModal,PickResultUpload},
        props:{
            visible:{
                type:Boolean,
                default:false
            },
            param:{
                type:Object,
                default: ()=>{
                    return {}
                }
            },
            execName:{
                type:String,
                default:''
            },
            projectId:{
                type:String,
                default:''
            },
            execId:{
                type:String,
                default:''
            },
        },
        data() {
            return {
                confirmLoading: false,
                planName:'',
                projectName:'',
                leaderName:'',
                startDate:'',
                endData:'',
                finishCount:0,
                dataSource:[],
                pickResultUploadVisable:false,
                pickResultUploadBackChange:null,
                pickResultUploadParam:null,
                checkInfoModalVisable:false,
                checkInfoModalBackChange:null,
                checkInfoModalParam:null,
                columns: [
                    {
                        title: '序号',
                        dataIndex: 'index',
                        width: '90px',
                        align:'center',
                    },
                    {
                        title: '受检单位名称',
                        dataIndex: 'targetName',
                        width: '250px',
                        align:'center',
                        ellipse:true,
                    },
                    {
                        title: '抽样数量',
                        dataIndex: 'pickCount',
                        width: '100px',
                        align:'center',
                    },
                    {
                        title: '检测品种',
                        dataIndex: 'pickType',
                        width: '150px',
                        align:'center',
                        ellipse:true,
                    },
                    {
                        title: '检测数量',
                        dataIndex: 'checkCount',
                        width: '100px',
                        align:'center',
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        align:'center',
                        scopedSlots: { customRender: 'operation' },
                    },
                ],
                form:{
                    jieguo:'',
                },
            };
        },
        created(){
            this.getData();
        },
        methods: {
            getData(){
                if (this.projectId&&this.execId) {
                    this.confirmLoading = true;
                    initApi({projectId:this.projectId,execId:this.execId}).then((result => {
                        if(result.data&&result.data.succ&&result.data.data)
                        {
                            this.dataSource=result.data.data;
                            let i=1;
                            this.dataSource.forEach(item=>{
                                this.planName=item.planName;
                                this.projectName=item.projectName;
                                this.leaderName=item.leaderName;
                                this.startDate=item.startDate;
                                this.endDate=item.endDate;
                                item.index=i++;
                                if(item.checkFileId&&item.checkCount)
                                {
                                    this.finishCount=Number(item.checkCount)+this.finishCount;
                                }
                            })
                        }
                        this.confirmLoading = false;

                    })).catch(() => {
                        this.confirmLoading = false;
                    });
                }
            },
            handleCancel(e) {
                this.$emit("update:visible",false)
            },
            onPickResultUploadOpen2(record){
                this.pickResultUploadParam={id:record.pickId,disabled:true};
                this.pickResultUploadVisable=true;
                //TODO: 无
            },
            onCheckInfoModalOpen(record){
                this.checkInfoModalParam={id:record.pickId,pickId:record.pickId,checkId:record.checkId};
                this.checkInfoModalVisable=true;
                //TODO: 无
            },
        },
    }
</script>

<style scoped lang="scss">

    /*/deep/ .ant-modal-body{*/
    /*height: 70vh;*/
    /*overflow-y: scroll;*/
    /*}*/
    /deep/ .ant-table-wrapper {
        .ant-table {
            border-top: 1px solid rgba(15, 41, 61, 0.45);
            border-bottom: 1px solid rgba(15, 41, 61, 0.45);
            border-image: initial;
            border-left: none;
            border-right: none;
        }
        .ant-table-thead {
            background: #fafafa;
        }
        .ant-table-thead > tr > th {
            font-weight: 500;
            line-height: 2;
            color: rgba(21, 40, 77, 0.65);
            background-color: rgb(245, 250, 255);
        }

        .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
            padding: 2px 2px;
        }
    }
</style>